export default {
    CONTACT_INFO: 'hello.task.contactInfo',
    APP_NAMING: 'hello.task.appNaming',
    AFFILIATIONS: 'hello.task.affiliations',
    DEVELOPER_ACCOUNT: 'hello.task.developerAccount',
    APP_ICONOGRAPHY: 'hello.task.appIcons',
    APP_COLORS: 'hello.task.appColors',
    VENUES: 'hello.task.venues',
    TEAMS: 'hello.task.teams',
    FEATURES: 'hello.task.features'
}
